<template>
  <div :class="$style.container" v-if="recentEventLogs">
    <div :class="$style.titleSection">
      <div :class="$style.title">HISTORY</div>
    </div>

    <div :class="$style.contentSection">
      <template v-if="histories.length > 0">
        <p-list-item
          v-for="(history, index) in histories"
          :key="`activity${index}`"
          :title="`${history.datetime}`"
        >
          <template v-if="history.eventPayload.isProjectLevel !== true">
            <p v-if="history.eventType === 'ADD_NEW_PARTICIPANT'">
              {{ getUserName(history.eventPayload.originator.oicPayload) }}
              added a new participant to
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="`/audits/` + history.eventPayload.auditId + `#dashboard`"
                >{{
                  getFormattedTitle(history.eventPayload.auditName)
                }}</router-link
              >
              in
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="'/projects/' + history.eventPayload.projectId + ''"
                >{{
                  getFormattedTitle(history.eventPayload.projectName)
                }}</router-link
              >
            </p>
            <p v-else-if="history.eventType === 'REMOVE_PARTICIPANT'">
              {{ getUserName(history.eventPayload.originator.oicPayload) }}
              removed participant from
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="`/audits/` + history.eventPayload.auditId + `#dashboard`"
                >{{
                  getFormattedTitle(history.eventPayload.auditName)
                }}</router-link
              >
              in
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="'/projects/' + history.eventPayload.projectId + ''"
                >{{
                  getFormattedTitle(history.eventPayload.projectName)
                }}</router-link
              >
            </p>
            <p v-else-if="history.eventType === 'ADD_NEW_CRITERIA'">
              {{ getUserName(history.eventPayload.originator.oicPayload) }}
              added a data collection period criteria to
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="`/audits/` + history.eventPayload.auditId + `#dashboard`"
                >{{
                  getFormattedTitle(history.eventPayload.auditName)
                }}</router-link
              >
              in
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="'/projects/' + history.eventPayload.projectId + ''"
                >{{
                  getFormattedTitle(history.eventPayload.projectName)
                }}</router-link
              >
            </p>
            <p v-else-if="history.eventType === 'REMOVE_CRITERIA'">
              {{ getUserName(history.eventPayload.originator.oicPayload) }}
              removed a data collection period criteria from
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="`/audits/` + history.eventPayload.auditId + `#dashboard`"
                >{{
                  getFormattedTitle(history.eventPayload.auditName)
                }}</router-link
              >
              in
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="'/projects/' + history.eventPayload.projectId + ''"
                >{{
                  getFormattedTitle(history.eventPayload.projectName)
                }}</router-link
              >
            </p>
            <p v-else-if="history.eventType === 'ADD_FORMER_PROJECT_OWNER'">
              {{ getUserName(history.eventPayload.originator.oicPayload) }}
              has changed project owner in
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="'/projects/' + history.eventPayload.projectId + ''"
                >{{
                  getFormattedTitle(history.eventPayload.projectName)
                }}</router-link
              >
            </p>
          </template>
          <template v-else>
            <p v-if="history.eventType === 'ADD_NEW_PARTICIPANT'">
              {{ getUserName(history.eventPayload.originator.oicPayload) }}
              added a new participant in
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="'/projects/' + history.eventPayload.projectId + ''"
                >{{
                  getFormattedTitle(history.eventPayload.projectName)
                }}</router-link
              >
            </p>
            <p v-else-if="history.eventType === 'REMOVE_PARTICIPANT'">
              {{ getUserName(history.eventPayload.originator.oicPayload) }}
              removed participant from
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="'/projects/' + history.eventPayload.projectId + ''"
                >{{
                  getFormattedTitle(history.eventPayload.projectName)
                }}</router-link
              >
            </p>
            <p v-else-if="history.eventType === 'ADD_NEW_CRITERIA'">
              {{ getUserName(history.eventPayload.originator.oicPayload) }}
              added a data collection period criteria in
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="'/projects/' + history.eventPayload.projectId + ''"
                >{{
                  getFormattedTitle(history.eventPayload.projectName)
                }}</router-link
              >
            </p>
            <p v-else-if="history.eventType === 'REMOVE_CRITERIA'">
              {{ getUserName(history.eventPayload.originator.oicPayload) }}
              removed a data collection period criteria from
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="'/projects/' + history.eventPayload.projectId + ''"
                >{{
                  getFormattedTitle(history.eventPayload.projectName)
                }}</router-link
              >
            </p>
            <p v-else-if="history.eventType === 'ADD_FORMER_PROJECT_OWNER'">
              {{ getUserName(history.eventPayload.originator.oicPayload) }}
              has changed project owner in
              <router-link
                :class="$style.descriptionLinkStyle"
                :to="'/projects/' + history.eventPayload.projectId + ''"
                >{{
                  getFormattedTitle(history.eventPayload.projectName)
                }}</router-link
              >
            </p>
          </template>
        </p-list-item>
      </template>
      <div :class="$style.noDataState" v-else>No history found</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '@/utils/date.util';
import { useUserEmail } from '@/utils/user.util';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';

@Component({
  components: {},
})
export default class DashboardRecentEventLogs extends Vue {
  @Action('projects/getRecentEventLogs')
  public getRecentEventLogs!: () => void;

  @State((state) => state.projects.recentEventLogs)
  public recentEventLogs!: any;

  @State((state) => state.projects.apiState.getRecentEventLogs)
  public getRecentEventLogsState!: any;

  public histories: any = [];

  public mounted() {
    this.getRecentEventLogs();
  }

  @Watch('getRecentEventLogsState.success')
  @isTruthy
  public watchGetRecentEventLogsState() {
    this.histories = this.recentEventLogs
      .filter((log: any) => {
        return log.eventPayload.originator;
      })
      .map((log: any) => {
        const today = dayjs().format(DATE_FORMAT);
        const yesterday = dayjs().add(-1, 'day').format(DATE_FORMAT);
        const dataUpdatedAt = dayjs(new Date(log.eventOccurredAt)).format(
          DATE_FORMAT,
        );

        let dateToDisplay;
        if (dataUpdatedAt === today) {
          dateToDisplay = 'Today';
        } else if (dataUpdatedAt === yesterday) {
          dateToDisplay = 'Yesterday';
        } else {
          dateToDisplay = dataUpdatedAt;
        }

        return {
          ...log,
          // @ts-ignore
          datetime: dateToDisplay,
        };
      });
  }

  public getUserName(userInfo: any) {
    const name = userInfo.name;
    const loggedInUserEmail = this.userEmail;
    if (loggedInUserEmail === userInfo.email) {
      return 'You';
    } else {
      return name;
    }
  }

  public getFormattedTitle(title: string) {
    if (title.length > 45) {
      return title.substring(0, 45) + '...';
    } else {
      return title;
    }
  }

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }
}
</script>

<style lang="scss" module>
.container {
  margin-bottom: 5rem;

  .titleSection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .title {
      font-weight: bold;
      text-transform: uppercase;
      padding: 8px 0;
    }

    .button {
      border: none;
      background: transparent;
      color: $primary;
    }
  }

  .contentSection {
    box-shadow: 0 1px 2px $grey-border, 0 1px 2px $grey-border;
    border: 0.5px solid $grey-border;
    overflow: hidden;
    border-radius: 6px;
    background: white;
  }

  .noDataState {
    padding: 1rem;
    font-size: 18px;
    font-weight: bold;
    color: #9f9f9f;
    text-align: center;
    height: 155px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .descriptionLinkStyle {
    font-weight: bold;
    color: #4a4a4a;
  }
  .descriptionLinkStyle:hover {
    text-decoration: underline;
  }
}
</style>
